import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

// MD UI Dashboard PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// MD UI Dashboard PRO React example components
import DataTable from "examples/Tables/DataTable";
import AppData from "../components/data-tables/data/dataTableData";
import CreateModal from "../components/CreateModal";
import { useEffect } from "react";
import Loader from "examples/Loader";

function Default() {
  const { dataTableData, handleRefresh, apps, loader, teamTags } = AppData();

  const onLoad = () => { };

  useEffect(onLoad, []);


  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <MDBox px={3}>
                  <MDBox sx={{ textAlign: 'right' }}>
                    <CreateModal
                      apps={apps}
                      teamTags={teamTags}
                      handleRefresh={handleRefresh}
                    />
                  </MDBox>
                  <DataTable
                    table={dataTableData}
                    canSearch
                    entriesPerPage={25}
                  />
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>

          {/* <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <MDBox
                  mx={2}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h6" color="white">
                    Staff
                  </MDTypography>
                  <CreateModal
                    products={products}
                    apps={apps}
                    handleRefresh={handleRefresh}
                  />
                </MDBox>
                <MDBox pt={3} px={3}>
                  <DataTable
                    table={dataTableData}
                    canSearch
                    entriesPerPage={25}
                  />
                </MDBox>
              </Grid>
            </Grid>
          </MDBox> */}
        </>
      )}
    </>
  )
}

export default Default;
